module.exports = __webpack_public_path__ + "static/media/2021-sy.5316daf9.jpg";